// Home image carousel — centered Swiper with side slides peeking on either edge.
// Slide width is set in SCSS; we use slidesPerView: 'auto' so the layout obeys CSS.

import Swiper from 'imports/swiper/swiper-bundle.esm.js'

const imageCarousel = {
    init() {
        document.querySelectorAll('.image-carousel-block').forEach((wrap) => {
            const el = wrap.querySelector('[data-image-carousel]')
            if (!el) return

            const prev = wrap.querySelector('.ic-prev')
            const next = wrap.querySelector('.ic-next')

            new Swiper(el, {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 32,
                loop: true,
                grabCursor: true,
                watchOverflow: true,
                speed: 450,
                longSwipesRatio: 0.2,
                longSwipesMs: 150,
                slideToClickedSlide: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                    disabledClass: 'swiper-button-disabled',
                },
                breakpoints: {
                    750: {
                        spaceBetween: 80,
                    },
                    1200: {
                        spaceBetween: 155,
                    },
                },
            })
        })
    }
}

export default imageCarousel
